<script lang="ts">
	import { wikiStyles } from '$lib/components/common/ui/wiki';
</script>

<article class="max-w-3xl mx-auto">
	<h1 class={wikiStyles.headerText}>Cob Building</h1>

	<p class={wikiStyles.paragraphText}>
		Cob is a natural building material made from subsoil, water, fibrous organic material (typically
		straw), and sometimes lime. This ancient technique creates durable, sculptural structures with
		excellent thermal mass properties.
	</p>

	<h2 class={wikiStyles.subheaderText}>Material Components</h2>
	<ul class={wikiStyles.ulText}>
		<li>Clay-rich Subsoil (20-30% clay)</li>
		<li>Sand (for structural strength)</li>
		<li>Straw (adds tensile strength)</li>
		<li>Water (for proper consistency)</li>
		<li>Optional: Lime (for wet climates)</li>
	</ul>

	<h2 class={wikiStyles.subheaderText}>Building Process</h2>
	<div class={wikiStyles.paragraphText}>
		<p class="mb-4">Key steps in cob construction:</p>
		<ul class="list-disc pl-6 space-y-2">
			<li>Soil Testing and Material Preparation</li>
			<li>Foundation Construction</li>
			<li>Mixing Cob</li>
			<li>Wall Building</li>
			<li>Sculpting Features</li>
			<li>Weather Protection</li>
		</ul>
	</div>

	<h2 class={wikiStyles.subheaderText}>Advantages</h2>
	<p class={wikiStyles.paragraphText}>Benefits of cob construction include:</p>
	<ul class={wikiStyles.ulText}>
		<li>Low environmental impact</li>
		<li>Fire-resistant properties</li>
		<li>Excellent thermal mass</li>
		<li>Creative design possibilities</li>
		<li>Community-friendly building process</li>
		<li>Durability (structures can last centuries)</li>
	</ul>

	<h2 class={wikiStyles.subheaderText}>Related Articles</h2>
	<ul class="space-y-2 text-bloomBlueLightActive">
		<li><a href="/learn/wiki/natural-building" class="underline">Natural Building</a></li>
		<li><a href="/learn/wiki/earthships" class="underline">Earthships</a></li>
		<li><a href="/learn/wiki/living-roofs" class="underline">Living Roofs</a></li>
	</ul>
</article>
